import React, { useEffect, useState } from "react";
import { db, storage } from "../../../config/firebase";
import { getDownloadURL, ref } from "firebase/storage";
import { COLLECTION, SESSION } from "../../../data/constant";
import { doc, getDoc,getDocs,where,query ,collection} from "firebase/firestore";

import Layout from "./Layout";

const Help = () => {
  const [userId, setUserId] = useState(null);


  useEffect(() => {
    const fetchDocuments = async () =>    {
      try {
        // Retrieve session ID from local storage
        const sessionId = localStorage.getItem(SESSION.PUSER_SESSION_ID);
        if (!sessionId) {
          throw new Error("Session ID not found");
        }
  
        // Get user information based on session
        const sessionRef = doc(db, COLLECTION.PUSER_SESSION, sessionId);
        const sessionSnap = await getDoc(sessionRef);
  
        if (!sessionSnap.exists()) {
          throw new Error("Session data not found");
        }
  
        const { userId } = sessionSnap.data();
        setUserId(userId)

      } catch (error) {
        console.error("Error fetching documents:", error);
      } 
    };
  
    fetchDocuments();
  }, []);
  

  return (
    <Layout
      userId={userId}
    />
  );
};

export default Help;
